// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationOutlinedSvg from "@ant-design/icons-svg/es/asn/NotificationOutlined";
import AntdIcon from '../components/AntdIcon';

var NotificationOutlined = function NotificationOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationOutlinedSvg
  }));
};

NotificationOutlined.displayName = 'NotificationOutlined';
export default React.forwardRef(NotificationOutlined);